import {UserOrganization} from "../model/types";

type FilterUsersProps = {
  users: UserOrganization[];
  searchTerm: string;
};

export const filterUsers = ({users, searchTerm}: FilterUsersProps) => {
  return users.filter((user) =>
    user.name.includes(searchTerm.trim())
    || user.email.includes(searchTerm.trim())
    || user.organization.includes(searchTerm.trim())
  );
};
